import { yupResolver } from '@hookform/resolvers/yup';
import { AuthCredentials } from 'core/domains/auth';
import { UIEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { authCredentialsSchema } from '../helpers/auth-credentials-schema';

export const useLoginForm = () => {
  const passwordTypes = { password: 'password', text: 'text' };
  const [passwordType, setPasswordType] = useState(passwordTypes.password);
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, dirtyFields, isValid, isLoading, isSubmitting },
  } = useForm<AuthCredentials>({
    resolver: yupResolver(authCredentialsSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    delayError: 800,
  });
  const showPassword = (event: UIEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    if (passwordTypes.password === passwordType) {
      setPasswordType(passwordTypes.text);

      handleTracking(event);
    } else {
      setPasswordType(passwordTypes.password);
    }
  };

  const handleTracking = (
    event: React.FocusEvent<HTMLInputElement> | UIEvent<HTMLButtonElement>,
  ) => {
    const {
      currentTarget: { dataset },
    } = event;

    window.dataLayer.push({
      event: 'analytics-event',
      event_parameters: {
        event_name: dataset.eventname,
        cd_interaction_detail: dataset.title,
      },
    });
  };

  const handleOnTooltipTracking =
    (method: string) =>
    (event: React.FocusEvent<HTMLInputElement> | UIEvent<HTMLButtonElement>) => {
      event.preventDefault();
      const {
        currentTarget: { dataset },
      } = event;

      window.dataLayer.push({
        event: 'analytics-event',
        event_parameters: {
          event_name: dataset.eventname,
          cd_interaction_detail: `${method}:${dataset.title}`,
        },
      });
    };

  return {
    passwordType,
    handleTracking,
    handleOnTooltipTracking,
    handleSubmit,
    register,
    showPassword,
    getValues,
    validationErrors: errors,
    dirtyFields,
    isValid,
    isLoading,
    isSubmitting,
  };
};
